import { Navigate, useParams } from 'react-router-dom';

import { useGetGrupoActivo } from '@/shared/actions/erp/activos';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveGrupoActivos } from '../../shared/saveGrupoActivos';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateGrupoActivosPageInterface {}

const UpdateGrupoActivosPage: React.FC<UpdateGrupoActivosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_grupoactivo)

  const { id } = useParams();
  const { data, isLoading } = useGetGrupoActivo(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_grupo_activo) return <Navigate to="/activos/grupo-activos" />;

  return <SaveGrupoActivos titlePage="Editar Grupo Activos" editGrupoActivos={data.data} />;
};

export default UpdateGrupoActivosPage;
